var swipe = function (elemento, onSwipeLeft, onSwipeRight, umbral, anguloMaximo // Ángulo máximo en grados para considerar un swipe horizontal
) {
    if (umbral === void 0) { umbral = 50; }
    if (anguloMaximo === void 0) { anguloMaximo = 30; }
    var startX;
    var startY;
    var endX;
    var endY;
    var isDragging = false;
    var handleTouchStart = function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
    };
    var handleTouchEnd = function (e) {
        endX = e.changedTouches[0].clientX;
        endY = e.changedTouches[0].clientY;
        procesarSwipe();
    };
    var handleMouseDown = function (e) {
        e.preventDefault();
        startX = e.clientX;
        startY = e.clientY;
        isDragging = true;
        document.addEventListener('mouseup', handleMouseUp);
        document.addEventListener('mousemove', handleMouseMove);
        elemento.style.userSelect = 'none';
        elemento.style.webkitUserSelect = 'none';
    };
    var handleMouseMove = function (e) {
        if (!isDragging)
            return;
        e.preventDefault();
    };
    var handleMouseUp = function (e) {
        endX = e.clientX;
        endY = e.clientY;
        isDragging = false;
        document.removeEventListener('mouseup', handleMouseUp);
        document.removeEventListener('mousemove', handleMouseMove);
        elemento.style.userSelect = '';
        elemento.style.webkitUserSelect = '';
        procesarSwipe();
    };
    var procesarSwipe = function () {
        if (!startX || !endX || !startY || !endY)
            return;
        var deltaX = startX - endX;
        var deltaY = startY - endY;
        // Calcular el ángulo del movimiento en grados
        var angulo = Math.abs(Math.atan2(deltaY, deltaX) * 180 / Math.PI);
        // Verificar si el movimiento es predominantemente horizontal
        var esHorizontal = angulo <= anguloMaximo || angulo >= (180 - anguloMaximo);
        if (Math.abs(deltaX) > umbral && esHorizontal) {
            if (deltaX > 0) {
                onSwipeLeft();
            }
            else {
                onSwipeRight();
            }
        }
        startX = undefined;
        startY = undefined;
        endX = undefined;
        endY = undefined;
    };
    // Instalar eventos
    elemento.addEventListener('touchstart', handleTouchStart, { passive: true });
    elemento.addEventListener('touchend', handleTouchEnd);
    elemento.addEventListener('mousedown', handleMouseDown);
    // Prevenir arrastre en imágenes
    elemento.querySelectorAll('img').forEach(function (img) {
        img.setAttribute('draggable', 'false');
        img.style.pointerEvents = 'none';
    });
    // Función para eliminar eventos
    var destruir = function () {
        elemento.removeEventListener('touchstart', handleTouchStart);
        elemento.removeEventListener('touchend', handleTouchEnd);
        elemento.removeEventListener('mousedown', handleMouseDown);
        document.removeEventListener('mouseup', handleMouseUp);
        document.removeEventListener('mousemove', handleMouseMove);
    };
    return { destruir: destruir };
};
export default swipe;
